import { Request } from "../../request";
import { getURL } from "../../utils";

export const get_credit = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        code: 200,
        success: true,
        message: "",
        pagination: {
          count: 1,
          pages: 1,
          page: 1,
          limit: 10,
          next: null,
          next_url: null,
          previous: null,
          previous_url: null,
        },
        data: [
          {
            id: 1608027,
            amount: -714000,
            user: {
              fullname: "حسام زندیان",
            },
            created_at: "1401/10/11",
            current_total_amount: 4286000,
          },
          {
            id: 1608027,
            amount: 5000000,
            user: {
              fullname: "حسام زندیان",
            },
            created_at: "1401/10/11",
            current_total_amount: 5000000,
          },
        ],
        extra: {},
        meta: {
          site: "helix",
          site_id: 4,
          version: "1.3.8\n",
          app_version: "0.0.0",
        },
      });
    }, 500);
  });
};

export const export_credit_excel = (data) => {
  return Request.rawGet(getURL("/api/corporation-pa/accounts/company-employee-credits/"), data);
};

export const add_credit = (data) => {
  return Request.post(getURL(`/api/corporation-pa/accounts/company-employee-credits/`),data);
};
